import { defineComponent, h } from 'vue';
import { QBtn } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import BaseComponent from './BaseComponentMixin.jsx';
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'

const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],
    [
        'link',
        'image',
        'video',
    ],

    [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'list': 'check' }],
    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],
    ['emoji'],
    ['clean'],                                        // remove formatting button
];

export default defineComponent({
    name: "rooster-editor-dsgn",
    mixins: [BaseComponent],
    components: {
        QBtn,
        QuillEditor
    },
    data: function () {
        return {
            quillkey: utils.generateUUID(),
            options: {
                placeholder: this.getPlaceholder(),
                modules: {
                    toolbar: this.controlData.EnableFormatting ? toolbarOptions : false,
                }
            }
        }
    },
    props: {
        type: null,
        schemakey: null,
    },
    computed: {
        maxHeight() {
            return this.controlData.MaxHeight;
        },
        enableFormatting() {
            return this.controlData.EnableFormatting;
        },
        contentFormat() {
            const raw = this.controlData?.ContentFormat || 'html';
            const normalized = String(raw).trim().toLowerCase();
            return normalized === 'markdown' || normalized === 'md' ? 'markdown' : 'html';
        },
        emitMarkdown() {
            return !!this.controlData?.EmitMarkdown;
        }
    },
    watch: {
        enableFormatting(newv) {
            // Force QuillEditor to refresh
            console.log(`EnableFormatting:${newv}`);
            this.quillkey = utils.generateUUID();
            this.options = {
                placeholder: this.getPlaceholder(),
                modules: {
                    toolbar: newv ? toolbarOptions : false,
                }
            };
        },
        contentFormat() {
            this.options = {
                ...this.options,
                placeholder: this.getPlaceholder(),
            };
        },
        emitMarkdown() {
            this.options = {
                ...this.options,
                placeholder: this.getPlaceholder(),
            };
        }
    },
    methods: {
        getPlaceholder() {
            const modeText = this.contentFormat === 'markdown' ? 'markdown input' : 'html input';
            const outputText = this.emitMarkdown ? 'markdown output' : 'html output';
            return `Please enter some text... (${modeText}, ${outputText})`;
        },
    },
    render() {
        let sendbtn;
        if (this.controlData.ShowSendButton)
            sendbtn = <QBtn icon="mdi-send" color="primary" disable>Send</QBtn>;

        return (
            <div
                class={{ 'designer-container': true, selected: this.selected$ }}
                style={{ ...utils.getSize(this.controlData ? this.controlData.SizeOptions : null, this.parentType, this.$parent), display: 'flex', flexDirection: 'column' }}
                onClick={(e) => this.handleClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                
                    <QuillEditor theme="snow"
                        key={this.quillkey}
                        ref="quillEditor"
                        contentType="html"
                        options={this.options}
                        style={{ minHeight: this.maxHeight, overflow: 'auto', height: this.maxHeight, flexGrow: '1' }}>
                    </QuillEditor>
                    {sendbtn}
                
            </div>
        );
    }
});
// <div style="display: flex; flex-direction: column; flex-grow: 1;">
// </div>